/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconLayoutKanbanFilled = createReactComponent("filled", "layout-kanban-filled", "IconLayoutKanbanFilled", [["path", { "d": "M10 3a1 1 0 0 1 0 2h-6a1 1 0 1 1 0 -2z", "key": "svg-0" }], ["path", { "d": "M20 3a1 1 0 0 1 0 2h-6a1 1 0 0 1 0 -2z", "key": "svg-1" }], ["path", { "d": "M8 7a3 3 0 0 1 3 3v8a3 3 0 0 1 -3 3h-2a3 3 0 0 1 -3 -3v-8a3 3 0 0 1 3 -3z", "key": "svg-2" }], ["path", { "d": "M18 7a3 3 0 0 1 3 3v2a3 3 0 0 1 -3 3h-2a3 3 0 0 1 -3 -3v-2a3 3 0 0 1 3 -3z", "key": "svg-3" }]]);

export { IconLayoutKanbanFilled as default };
//# sourceMappingURL=IconLayoutKanbanFilled.mjs.map
